const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrussFrame(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 480",
    role: "img",
    style: {},
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "Two column portal frame with a single truss, flipped diagonal pattern") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "A simplified silhouette diagram of a portal frame: two columns rising to the top eave, supporting a single Warren-style truss with a mirrored diagonal pattern."), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 440,
    x2: 580,
    y2: 440,
    stroke: "var(--text-primary)",
    strokeWidth: 3,
    opacity: 0.35,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.35,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 140,
    width: 20,
    height: 300,
    fill: "var(--text-primary)",
    style: {
      fill: "rgb(11, 11, 11)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 140,
    width: 20,
    height: 300,
    fill: "var(--text-primary)",
    style: {
      fill: "rgb(11, 11, 11)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "var(--text-primary)",
    strokeLinecap: "round",
    fill: "none",
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 140,
    x2: 510,
    y2: 140,
    strokeWidth: 10,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 240,
    x2: 510,
    y2: 240,
    strokeWidth: 10,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 140,
    x2: 170,
    y2: 240,
    strokeWidth: 10,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 510,
    y1: 140,
    x2: 510,
    y2: 240,
    strokeWidth: 10,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 140,
    x2: 255,
    y2: 240,
    strokeWidth: 8,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255,
    y1: 240,
    x2: 340,
    y2: 140,
    strokeWidth: 8,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 140,
    x2: 425,
    y2: 240,
    strokeWidth: 8,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425,
    y1: 240,
    x2: 510,
    y2: 140,
    strokeWidth: 8,
    style: {
      fill: "none",
      stroke: "rgb(11, 11, 11)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrussFrame);
export default __webpack_public_path__ + "static/media/Truss_Frame.fbb526c0d621f1d48564a75db1352f13.svg";
export { ForwardRef as ReactComponent };